import { useSelector } from 'react-redux';

import { urls } from '@repo/app-constants';
import { ButtonColors } from 'components';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { usePortalConfigs } from 'hooks/usePortalConfigs';
import { useShouldShowConsults } from 'hooks/useShouldShowConsultLink';
import { getShouldHideConsults } from 'store/kits';
import { RecommendedCard } from 'views/Home/HomeContent/RecommendedForYou/components/RecommendedCard';
import { CARD_TITLE_COLORS } from 'views/Home/HomeContent/RecommendedForYou/constants/cardTitleColors';

import styles from './ScheduleConsultSidebarCard.module.css';

export const ScheduleConsultSidebarCard = () => {
  const { currentKit, currentKitId } = useCurrentKitAndTinyAccount();
  const shouldShowConsultLink = useShouldShowConsults(currentKit);
  const shouldHideConsults = useSelector(getShouldHideConsults(currentKit?.id));
  const { config } = usePortalConfigs(currentKit);
  const { trackEvent } = useAnalytics();

  if (!currentKit || !shouldShowConsultLink) {
    return null;
  }

  if (shouldHideConsults) {
    return (
      <RecommendedCard
        title='Join our facebook community'
        label=''
        imgStyles={styles.facebook}
        cardColor={styles.colorFacebook}
        titleColor={CARD_TITLE_COLORS.blue}
        buttonColor={ButtonColors.DARK_BLUE}
        clickable={{
          href: urls.FACEBOOK_GROUP,
          text: 'Visit group',
          isExternal: true,
        }}
        analyticsEventName='Clicked Button'
      />
    );
  }

  const title = config.hide_upsells ? (
    <>
      Have questions?
      <br />
      Get answers.
    </>
  ) : (
    <>Review your results with an expert</>
  );

  const label = config.hide_upsells
    ? 'Schedule a coaching call with our experts.'
    : 'Tiny+ members get 1 FREE consult session';

  return (
    <RecommendedCard
      title={title}
      label={label}
      imgStyles={
        config.hide_upsells ? styles.upsellConsult : styles.upsellConsultTiny
      }
      cardColor={styles.colorUpsellConsult}
      titleColor={CARD_TITLE_COLORS.yellow}
      titleContainerClassName={styles.wideTitleContainer}
      buttonColor={ButtonColors.MEDIUM_YELLOW}
      clickable={{
        href: `/results/${currentKitId}/consults/select-method`,
        text: 'Schedule Consult',
        isExternal: false,
      }}
      analyticsEventName='Clicked Button'
      onClick={() =>
        trackEvent('Schedule Call Clicked', {
          source: 'results_summary_sidebar',
        })
      }
    />
  );
};
